/* !
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { Classes } from "@blueprintjs/core";
var NS = Classes.getClassNamespace();
export var POPOVER2 = NS + "-popover2";
export var POPOVER2_ARROW = POPOVER2 + "-arrow";
export var POPOVER2_BACKDROP = POPOVER2 + "-backdrop";
export var POPOVER2_CAPTURING_DISMISS = POPOVER2 + "-capturing-dismiss";
export var POPOVER2_CONTENT = POPOVER2 + "-content";
export var POPOVER2_CONTENT_PLACEMENT = POPOVER2 + "-placement";
export var POPOVER2_CONTENT_SIZING = POPOVER2_CONTENT + "-sizing";
export var POPOVER2_DISMISS = POPOVER2 + "-dismiss";
export var POPOVER2_DISMISS_OVERRIDE = POPOVER2_DISMISS + "-override";
export var POPOVER2_OPEN = POPOVER2 + "-open";
export var POPOVER2_TARGET = POPOVER2 + "-target";
export var POPOVER2_TRANSITION_CONTAINER = POPOVER2 + "-transition-container";
export var TOOLTIP2 = NS + "-tooltip2";
export var TOOLTIP2_INDICATOR = TOOLTIP2 + "-indicator";
//# sourceMappingURL=classes.js.map